export default [
    {
        name: 'Despesas',
        url: '/despesasgerais/requisitantes/despesas',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'REQUISITANTE'
        },
        regras: 'DESP-GERAIS-REQ-00'
    },
    {
        name: 'Pagamentos',
        url: '/despesasgerais/requisitantes/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'REQUISITANTE'
        },
        regras: 'DESP-GERAIS-REQ-PAG-00'
    },
]